<template>
  <NuxtLayout>
    <CypressCoreHeader
      :description="workshopInfo?.description"
      :days="workshopInfo?.workshop_dates?.days"
      :date="workshopInfo?.workshop_dates?.date_display"
      :time="workshopInfo?.workshop_dates?.time"
    />
    <CypressCoreEndorsment />
    <CypressCoreOnTheRise />
    <CypressCoreImportance />
    <CypressCoreForm />
    <CypressCoreAbout />
    <CypressCoreContent />
    <CypressCoreRegistration :workshop-info="workshopInfo" />
    <CypressCoreFaq />
  </NuxtLayout>
</template>
<script setup lang="ts">
const { getWorkshopsByType } = useSupabaseWorkshops()

const { data } = await useAsyncData('cypress-core-workshop', async () => {
  const { workshops, error } = await getWorkshopsByType('core-workshop')
  if (error) {
    console.error('Error fetching core workshop:', error)
    return null
  }
  return workshops?.[0] || null
})

const workshopInfo = computed(() => data.value)

const route = useRoute()

defineOgImage({
  component: 'OgImageWorkshop',
  title: workshopInfo.value?.title || 'Cypress Core Workshop',
  image: workshopInfo.value?.image || '',
  description: workshopInfo.value?.description || '',
  date: workshopInfo.value?.workshop_dates?.date_display || '',
  days: workshopInfo.value?.workshop_dates?.days || ''
})

useHead({
  meta: [
    {
      property: 'og:url',
      content: `https://filiphric.com${route.path}`
    },
    {
      property: 'twitter:card',
      content: 'summary_large_image'
    },
    {
      property: 'twitter:creator',
      content: '@filip_hric'
    },
    {
      property: 'article:published_time',
      content: workshopInfo.value?.workshop_dates?.date_display
    },
    {
      property: 'article:author',
      content: 'Filip Hric'
    },
    {
      property: 'og:title',
      content: workshopInfo.value?.title
    },
    {
      property: 'og:description',
      content: workshopInfo.value?.description
    },
    {
      hid: 'description',
      name: 'description',
      content: workshopInfo.value?.description
    }
  ],
  link: [
    {
      rel: 'canonical',
      href: `https://filiphric.com${route.path}`
    }
  ]
})
</script>
